import { all, fork } from 'redux-saga/effects';
import rootNotificationSaga from '../features/notifications/notifications.saga';

function* rootSaga() {
  yield all([fork(rootNotificationSaga)]);
}

export default rootSaga;
